<template>
  <div class="contact">
    <div class="contact-strip">Super Collection</div>
    <div class="contact-hero">
      <div class="contact-hero-content">
        <div class="contact-hero-title">Contact Us</div>
        <div class="contact-hero-subtitle">We’re here to help!</div>
      </div>
    </div>
    <div class="contact-body">
      <div class="contact-intro">
        At Superpark Private Limited, customer support is our top priority. Whether you need
        assistance with your order, have questions about our products, or need help with returns,
        our team is always ready to support you.
      </div>
      <div class="contact-intro">
        Please feel free to reach us through any of the options below.
      </div>
      <div class="contact-grid">
        <div class="contact-card">
          <h3>Customer Support</h3>
          <p>Phone: +91 8131885933</p>
          <p>Available Monday to Friday</p>
          <p>Timing: 9:00 AM – 6:00 PM</p>
          <div class="contact-card-divider"></div>
          <p>Our support team will assist with:</p>
          <p>Order tracking | Product inquiries | Returns &amp; replacements | Payments &amp; refund status | Account help</p>
        </div>
        <div class="contact-card">
          <h3>Email Support</h3>
          <p>For all general queries, order issues, feedback, or business enquiries:</p>
          <p>Email: info@superparkshop.in | Superpark976@gmail.com</p>
          <div class="contact-card-divider"></div>
          <p>We aim to respond within 24–48 hours on working days.</p>
        </div>
        <div class="contact-card">
          <h3>Corporate Office Address</h3>
          <p>Superpark Private Limited</p>
          <p>Unit No. 0309, Tower B Plot No. A4 Logix Technova Sector 132, Noida, Gautam Buddha Nagar, Uttar Pradesh, 201304</p>
          <div class="contact-card-divider"></div>
          <p>(Visits by appointment only)</p>
        </div>
        <div class="contact-card">
          <h3>Order &amp; Return Help</h3>
          <p>You can manage your orders anytime through:</p>
          <p>My Account → Orders</p>
          <div class="contact-card-divider"></div>
          <p>Track your order | Request return or replacement | Cancel order (before dispatch) | Check refund status</p>
        </div>
        <div class="contact-card">
          <h3>When To Contact Us</h3>
          <p>Reach us for:</p>
          <p>Delivery issues | Damaged or wrong product received | Size or product queries | Delayed refunds | Payment-related issues | Feedback or complaints | Bulk order enquiries</p>
          <router-link class="contact-action" to="/contact-support">Contact Support</router-link>
        </div>
        <div class="contact-card">
          <h3>Grievance Redressal</h3>
          <p>As per Indian IT &amp; Consumer Protection rules, you may contact our Grievance Officer:</p>
          <p>Name: Ravit Malik</p>
          <p>Email: info@superparkshop.in</p>
          <p>Phone: +91 8131885933</p>
          <p>Working Hours: Monday – Friday (9:00 AM – 6:00 PM)</p>
          <div class="contact-card-divider"></div>
          <p>Complaints will be acknowledged within 48 hours and resolved within 30 days.</p>
        </div>
      </div>
      <div class="contact-feedback">
        <h3>We Value Your Feedback</h3>
        <p>Your satisfaction helps us grow.</p>
        <p>If you have suggestions or ideas that can improve your shopping experience, we’d love to hear from you.</p>
        <p>Thank you for choosing Superpark Private Limited ❤️</p>
        <p>We appreciate your trust and support.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactUs'
}
</script>

<style scoped>
.contact {
  background: #f4f4f4;
  min-height: 100vh;
}
.contact-strip {
  height: 36px;
  background-color: #0f0f14;
  color: #ffffff;
  text-align: center;
  line-height: 36px;
  font-size: 12px;
  letter-spacing: 1px;
  text-transform: uppercase;
}
.contact-hero {
  height: 200px;
  max-width: 1200px;
  margin: 24px auto 0;
  border-radius: 6px;
  background: url('/img/Untitled-design.webp') center / cover no-repeat;
  display: flex;
  align-items: center;
  color: #ffffff;
}
.contact-hero-content {
  width: 100%;
  padding: 0 32px;
}
.contact-hero-title {
  font-size: 36px;
  font-weight: 700;
}
.contact-hero-subtitle {
  margin-top: 6px;
  font-size: 16px;
  opacity: 0.9;
}
.contact-body {
  width: 1200px;
  margin: 0 auto;
  padding: 32px 24px 80px;
}
.contact-intro {
  font-size: 14px;
  line-height: 1.7;
  color: #3f3f3f;
  margin-bottom: 10px;
}
.contact-grid {
  margin-top: 24px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
}
.contact-card {
  background: #ffffff;
  border-radius: 6px;
  padding: 20px;
  box-shadow: 0 10px 20px rgba(15, 15, 20, 0.06);
  font-size: 13px;
  color: #4a4a4a;
  line-height: 1.7;
}
.contact-card h3 {
  font-size: 14px;
  margin-bottom: 10px;
  color: #1f1f1f;
  letter-spacing: 0.3px;
}
.contact-card p {
  margin: 0 0 8px;
}
.contact-card-divider {
  height: 1px;
  background: #ededed;
  margin: 10px 0;
}
.contact-action {
  margin-top: 12px;
  background: #b20710;
  color: #ffffff;
  text-align: center;
  padding: 6px 10px;
  border-radius: 3px;
  font-size: 12px;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  display: inline-block;
  width: 100%;
}
.contact-feedback {
  margin-top: 28px;
  background: #ffffff;
  border-radius: 6px;
  padding: 20px;
  color: #4a4a4a;
  box-shadow: 0 10px 20px rgba(15, 15, 20, 0.06);
}
.contact-feedback h3 {
  font-size: 14px;
  margin-bottom: 10px;
  color: #1f1f1f;
}
.contact-feedback p {
  margin: 0 0 8px;
  line-height: 1.7;
}
@media (max-width: 1280px) {
  .contact-hero {
    max-width: 100%;
    margin-top: 0;
    border-radius: 0;
  }
  .contact-body {
    width: 100%;
  }
}
@media (max-width: 1000px) {
  .contact-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 720px) {
  .contact-grid {
    grid-template-columns: 1fr;
  }
}
</style>
